// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__2RFJl","notes":"Notes_notes__15BGL"};